import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

const featuredCategories = comicCategories.slice(0, 6);

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            漫画类型大全
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            涵盖韩漫、日漫、国漫等热门类型，满足你的各种阅读口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?type=${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 hover:-translate-y-1"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="font-heading font-semibold text-foreground-800 text-sm md:text-base">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 text-center leading-relaxed hidden md:block">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            查看全部类型
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}